import { ClaimResponseType } from '../../../redux/actions/types'
import { discountType } from '../../../constants/constants'
import { createRuStatusValueForClaim } from '../../../utils/createStatusForClaims'

export const prepareInitialValues = (claimData: ClaimResponseType) => {
  const startDate = claimData.startDate.slice(0, 10).split('-').reverse().join('.')
  const startTime = claimData.startDate.slice(11, 16)
  const endDate = claimData.endDate.slice(0, 10).split('-').reverse().join('.')
  const endTime = claimData.endDate.slice(11, 16)

  return {
    arrangement: claimData?.arrangement ? claimData.arrangement : '',
    platformName: claimData?.place?.name ? claimData.place.name : '',
    platformId: claimData?.place?.id ? String(claimData.place.id) : '',
    city: claimData?.place?.city ? claimData.place.city : '',
    owner: claimData?.user?.fullName ? claimData.user.fullName : '',
    dateStart: claimData?.startDate ? startDate : '',
    timeStart: claimData?.startDate ? startTime : '',
    dateFinish: claimData?.endDate ? endDate : '',
    timeFinish: claimData?.endDate ? endTime : '',
    peopleCount: claimData?.peopleCount ? claimData.peopleCount : '',
    status: createRuStatusValueForClaim(claimData.status),
    price: claimData?.order?.totalPrice || 0,
    segment: claimData?.segment ? claimData.segment : '',
    client: claimData?.client
      ? claimData?.client?.fullName || claimData?.client?.organizationName
      : '',
    clientId: claimData?.client?.id || '',
    manager: claimData?.manager ? claimData?.manager?.fullName : '',
    serviceFeePercent: claimData?.serviceFeePercent,
    serviceFeeAmount: claimData?.serviceFeeAmount,
    corkFeePercent: claimData?.corkFeePercent || 0,
    corkFeeAmount: claimData?.corkFeeAmount || 0,
    discountPercent: claimData?.discountPercent,
    discountAmount: claimData?.discountAmount,
    discountType: claimData?.discountAmount == 0 ? discountType[0] : discountType[1],
    serviceFeeType: claimData?.serviceFeeAmount == 0 ? discountType[0] : discountType[1],
    corkFeeType: claimData?.corkFeeAmount == 0 ? discountType[0] : discountType[1],
    rejectionCause: claimData?.rejectionCause || null,
    paymentType: claimData?.paymentType || null,
    paymentStatus: claimData?.paymentStatus || 'Не оплачено',
    prepaymentAmount: Number(claimData?.prepaymentAmount) || 0,
    paid: Number(claimData?.paid || 0),
    services: (claimData as any)?.services || [],
    events:
      ((claimData as any)?.events || []).map((event: any) => {
        if (event.time) {
          const timeParts = event.time.split('—').map((t: string) => t.trim())
          return {
            ...event,
            timeStart: timeParts[0] || '',
            timeEnd: timeParts[1] || '',
          }
        }
        return {
          ...event,
          timeStart: event.timeStart || '',
          timeEnd: event.timeEnd || '',
        }
      }) || [],
  }
}
